export const KPI_BOOKED_MEETING = "booked_salesmeeting";
export const KPI_WON_MEETING = "won_salesmeeting";
export const KPI_SALES_CALLS = "made_sales_calls";
export const KPI_SOLD_OBJECTS = "sold_objects";
export const KPI_SENT_TIPS = "sent_tips";
export const KPI_EXTERNAL_TIPS = "externaltips";
